<template>
  <div class="modal-overflow" style="max-height: 600px;">
    <textarea id="taskTemplate" style="width: 100%; height: 500px;">
      {{ taskTemplateJson }}
    </textarea>
  </div>
</template>

<script>
import {notifySuccess} from 'src/utilities/utils'

export default {
  props: ['data'],
  computed: {
    taskTemplateJson() {
      const nonReactiveCopy = JSON.parse(JSON.stringify(this.data))
      delete nonReactiveCopy.createdAt
      delete nonReactiveCopy.createdBy
      delete nonReactiveCopy.updatedAt
      delete nonReactiveCopy.updatedBy
      delete nonReactiveCopy.entityType
      return JSON.stringify(nonReactiveCopy, undefined, 2)
    }
  },
  mounted() {
    const taskTemplate = document.getElementById('taskTemplate')
    taskTemplate.select()
    taskTemplate.setSelectionRange(0, 99999) // for mobile devices
    document.execCommand('copy')
    notifySuccess(this, this.data.name + ' has been copied to your clipboard')
  }
}
</script>
